import { render, staticRenderFns } from "./category-manager.vue?vue&type=template&id=841a7766&scoped=true"
import script from "./category-manager.ts?vue&type=script&lang=ts&external"
export * from "./category-manager.ts?vue&type=script&lang=ts&external"
import style0 from "./category-manager.less?vue&type=style&index=0&id=841a7766&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841a7766",
  null
  
)

export default component.exports